if (!customElements.get('truman-drawer')) {
  class TrumanDrawer extends HTMLElement {
    connectedCallback() {
      this.toggleBtn = this.toggleBtn || this.querySelector('[data-drawer-open]');
      this.panel = this.panel || this.querySelector('.tmd__panel');
      if (!this.toggleBtn || !this.panel) return;

      // Panel body me (position: fixed), top = header ka bottom
      document.body.appendChild(this.panel);

      this.controller = new AbortController();
      const signal = this.controller.signal;

      this.toggleBtn.addEventListener('click', () => (this.isOpen ? this.close() : this.open()), { signal });

      this.panel.querySelectorAll('[data-accordion]').forEach((btn) => {
        btn.addEventListener('click', () => this.toggleItem(btn), { signal });
      });

      document.addEventListener('keydown', (e) => this.onKeyDown(e), { signal });
      window.addEventListener('resize', () => this.isOpen && this.setTop(), { signal });

      this.mq = window.matchMedia('(min-width: 990px)');
      this.mq.addEventListener('change', (e) => e.matches && this.isOpen && this.close(false), { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      document.body.classList.remove('tmd-lock');
      this.panel?.remove();
    }

    get isOpen() {
      return this.panel.classList.contains('is-open');
    }

    setTop() {
      const header = this.closest('.header-wrapper') || this.closest('header') || this;
      const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      this.panel.style.setProperty('--tmd-top', `${bottom}px`);
    }

    open() {
      this.setTop();
      this.panel.removeAttribute('inert');
      this.panel.setAttribute('aria-hidden', 'false');
      this.toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('tmd-lock');
      requestAnimationFrame(() => {
        this.setTop();
        this.panel.classList.add('is-open');
      });
    }

    close(returnFocus = true) {
      this.panel.classList.remove('is-open');
      this.panel.setAttribute('aria-hidden', 'true');
      this.panel.setAttribute('inert', '');
      this.toggleBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('tmd-lock');
      if (returnFocus) this.toggleBtn.focus({ preventScroll: true });
    }

    toggleItem(btn) {
      const item = btn.closest('.tmd__item, .tmd__subitem');
      if (!item) return;
      const willOpen = !item.classList.contains('is-open');

      // Ek time par ek hi open (sirf usi level ke items me)
      if (this.panel.dataset.oneOpen !== 'false') {
        const level = item.classList.contains('tmd__subitem') ? '.tmd__subitem' : '.tmd__item';
        const scope = item.parentElement.closest('.tmd__item') || this.panel;
        scope.querySelectorAll(`${level}.is-open`).forEach((openItem) => {
          if (openItem !== item && openItem.parentElement.closest('.tmd__item, .tmd__subitem') === item.parentElement.closest('.tmd__item, .tmd__subitem')) {
            this.setItem(openItem, false);
          }
        });
      }
      this.setItem(item, willOpen);

      if (willOpen) {
        setTimeout(() => btn.scrollIntoView({ block: 'nearest', behavior: 'smooth' }), 320);
      }
    }

    setItem(item, open) {
      const btn = item.querySelector(':scope > [data-accordion]');
      const sub = item.querySelector(':scope > .tmd__sub');
      item.classList.toggle('is-open', open);
      btn?.setAttribute('aria-expanded', String(open));
      if (sub) open ? sub.removeAttribute('inert') : sub.setAttribute('inert', '');

      // Parent band ho to uske andar ke sub-sub menu bhi band
      if (!open) {
        item.querySelectorAll('.tmd__subitem.is-open').forEach((child) => this.setItem(child, false));
      }
    }

    onKeyDown(e) {
      if (!this.isOpen) return;
      if (e.key === 'Escape') {
        this.close();
        return;
      }
      if (e.key !== 'Tab') return;

      // Focus header ke X button + drawer ke andar hi rahe
      const focusables = [
        this.toggleBtn,
        ...[...this.panel.querySelectorAll('a[href], button:not([disabled])')].filter((el) => !el.closest('[inert]')),
      ];
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('truman-drawer', TrumanDrawer);
}

/* Truman: "Compare" checkboxes on lift cards + compare bar (collection pages only) */
(function () {
  if (!/^\/collections\//.test(location.pathname) || window.__trumanCmp) return;
  window.__trumanCmp = true;
  var KEY = 'truman_cmp', MAX = 3, OK = null, barEl = null;

  function get() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function set(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }

  var css = document.createElement('style');
  css.textContent =
    '.cmp-chk{position:relative;z-index:3;display:inline-flex;align-items:center;gap:7px;margin-top:9px;font-size:13px;font-weight:600;color:#255131;cursor:pointer;user-select:none;width:max-content}' +
    '.cmp-chk input{width:16px;height:16px;accent-color:#255131;margin:0;cursor:pointer}' +
    '.cmp-bar{position:fixed;left:0;right:0;bottom:0;z-index:60;background:#17392d;color:#fff;transform:translateY(110%);transition:transform .25s ease;box-shadow:0 -6px 20px rgba(0,0,0,.15)}' +
    '.cmp-bar.show{transform:none}' +
    '.cmp-in{max-width:1100px;margin:0 auto;display:flex;align-items:center;gap:14px;padding:10px 16px calc(10px + env(safe-area-inset-bottom,0px))}' +
    '.cmp-ths{display:flex;gap:8px}' +
    '.cmp-th{position:relative;width:52px;height:44px;border-radius:8px;background:#fff;display:flex;align-items:center;justify-content:center}' +
    '.cmp-th img{max-width:46px;max-height:40px;object-fit:contain}' +
    '.cmp-th button{position:absolute;top:-7px;right:-7px;width:20px;height:20px;border-radius:50%;border:0;background:#e9b439;color:#17392d;font-weight:800;font-size:13px;line-height:20px;padding:0;cursor:pointer}' +
    '.cmp-empty{background:transparent;border:1.5px dashed rgba(255,255,255,.4);color:rgba(255,255,255,.6);font-size:18px}' +
    '.cmp-txt{flex:1;display:flex;flex-direction:column;font-size:14px;min-width:0}' +
    '.cmp-msg{font-size:12.5px;color:rgba(255,255,255,.8)}.cmp-msg.warn{color:#f3d27a}' +
    '.cmp-clear{background:none;border:0;color:rgba(255,255,255,.85);text-decoration:underline;cursor:pointer;font-size:13px}' +
    '.cmp-go{background:#e8d48f;color:#17392d !important;font-weight:800;border-radius:10px;padding:11px 16px;text-decoration:none;white-space:nowrap}' +
    '.cmp-go.off{opacity:.5}' +
    '@media(max-width:600px){.cmp-th{width:42px;height:38px}.cmp-th img{max-width:36px;max-height:32px}.cmp-clear{display:none}.cmp-in{gap:10px;padding-left:12px;padding-right:12px}}';
  document.head.appendChild(css);

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^?#\/]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function decorate() {
    if (!OK) return;
    var sel = get().map(function (x) { return x.h; });
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      var h = handleOf(card);
      if (!h || !OK[h]) return;
      var lab = card.querySelector('.cmp-chk');
      if (!lab) {
        lab = document.createElement('label');
        lab.className = 'cmp-chk';
        lab.innerHTML = '<input type="checkbox"><span>Compare</span>';
        var host = card.querySelector('.card > .card__content .card__information') || card;
        host.appendChild(lab);
        lab.addEventListener('click', function (e) { e.stopPropagation(); });
        lab.querySelector('input').addEventListener('change', function () { toggle(h, this); });
      }
      lab.querySelector('input').checked = sel.indexOf(h) > -1;
    });
  }

  function toggle(h, inp) {
    var a = get();
    var i = -1;
    a.forEach(function (x, k) { if (x.h === h) i = k; });
    if (inp.checked) {
      if (a.length >= MAX) { inp.checked = false; flash('You can compare up to 3 lifts. Remove one first.'); return; }
      if (i < 0) a.push({ h: h, t: OK[h].t, i: OK[h].i });
    } else if (i > -1) a.splice(i, 1);
    set(a);
    bar();
  }

  function bar() {
    var a = get();
    if (!barEl) {
      barEl = document.createElement('div');
      barEl.className = 'cmp-bar';
      document.body.appendChild(barEl);
      barEl.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-rm]');
        if (rm) { var hh = rm.getAttribute('data-rm'); set(get().filter(function (x) { return x.h !== hh; })); bar(); decorate(); return; }
        if (e.target.closest('[data-clear]')) { set([]); bar(); decorate(); return; }
        if (e.target.closest('.cmp-go.off')) { e.preventDefault(); flash('Pick at least 2 lifts to compare.'); }
      });
    }
    if (!a.length) { barEl.classList.remove('show'); return; }
    var th = a.map(function (x) {
      return '<span class="cmp-th">' + (x.i ? '<img src="' + x.i + '" alt="">' : '') + '<button type="button" data-rm="' + x.h + '" aria-label="Remove">&times;</button></span>';
    }).join('');
    for (var k = a.length; k < MAX; k++) th += '<span class="cmp-th cmp-empty">+</span>';
    var ready = a.length >= 2;
    var href = ready ? '/pages/compare-lifts?ids=' + a.map(function (x) { return encodeURIComponent(x.h); }).join(',') : '#';
    barEl.innerHTML = '<div class="cmp-in"><div class="cmp-ths">' + th + '</div><div class="cmp-txt"><b>' + a.length + ' of 3 selected</b><span class="cmp-msg">' + (ready ? 'Ready to compare' : 'Pick at least 2 lifts') + '</span></div><button type="button" class="cmp-clear" data-clear>Clear</button><a class="cmp-go' + (ready ? '' : ' off') + '" href="' + href + '">Compare &rarr;</a></div>';
    barEl.classList.add('show');
  }

  function flash(t) {
    bar();
    var m = barEl && barEl.querySelector('.cmp-msg');
    if (m) { m.textContent = t; m.classList.add('warn'); }
  }

  fetch('/collections/all-automotive-lifts/products.json?limit=250')
    .then(function (r) { return r.json(); })
    .then(function (d) {
      OK = {};
      (d.products || []).forEach(function (p) {
        var t = p.product_type || '';
        if (/lift/i.test(t) && !/accessor|bridge jack|table|rotisser/i.test(t)) {
          var img = p.images && p.images[0] ? p.images[0].src : '';
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          OK[p.handle] = { t: p.title, i: img };
        }
      });
      decorate();
      bar();
      var timer;
      new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(decorate, 150); })
        .observe(document.body, { childList: true, subtree: true });
    })
    .catch(function () {});
})();

/* Truman: products that have their own landing page.
   Links to these products point to the landing page instead, and opening the
   product page directly forwards to the landing page. Add more as handle: url. */
(function () {
  if (window.__trumanLanding) return;
  window.__trumanLanding = true;
  var LANDING = {
    'ravaglioli-trubay-alignment-system': '/pages/ravaglioli-trubay',
    'trolley-for-rav-td2-0-alignment-machine': '/pages/ravaglioli-trubay'
  };
  var inEditor = window.Shopify && window.Shopify.designMode;
  var keep = /[?&]preview_theme_id=/.test(location.search) ? location.search : '';

  function handleFrom(path) {
    var m = (path || '').match(/\/products\/([^?#\/]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Product page opened directly: forward to its landing page
  var here = handleFrom(location.pathname);
  if (here && LANDING[here] && !inEditor) {
    location.replace(LANDING[here] + keep);
    return;
  }

  function rewrite(root) {
    (root || document).querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var h = handleFrom(a.getAttribute('href'));
      if (h && LANDING[h] && a.getAttribute('data-landing') !== '1') {
        a.setAttribute('href', LANDING[h]);
        a.setAttribute('data-landing', '1');
      }
    });
  }

  function start() {
    rewrite();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(rewrite, 120); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
